var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ghost-input"},[_c('Input',{attrs:{"clearable":false},on:{"input":_vm.handleInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('div',{staticClass:"hidden-text",style:(`max-width:${_vm.maxWidth}px`)},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }